/**
 * GSET007 (BusinessPartnerList) partner-type display and header-filter helpers.
 * Display skips the party_mode sentinel "none". Raw types / party_mode are never mutated.
 */

const TYPE_I18N_KEYS = Object.freeze({
  customer: 'BusinessPartnerList.PartnerType.Customer',
  client: 'BusinessPartnerList.PartnerType.Client',
  supplier: 'BusinessPartnerList.PartnerType.Supplier',
  calibration_company: 'BusinessPartnerList.PartnerType.CalibrationCompany',
  training_company: 'BusinessPartnerList.PartnerType.TrainingCompany',
  service_company: 'BusinessPartnerList.PartnerType.ServiceCompany',
});

export const BUSINESS_PARTNER_TYPE_EMPTY_LABEL = '—';

export const BUSINESS_PARTNER_TYPE_FILTER_VALUES = Object.freeze([
  'customer',
  'client',
  'supplier',
  'calibration_company',
  'training_company',
  'service_company',
]);

export function parseCompanyPartnerHeaderMulti(headerValue) {
  if (headerValue == null || headerValue === '') return [];
  if (Array.isArray(headerValue)) return headerValue.map((x) => String(x ?? '').trim()).filter(Boolean);
  if (typeof headerValue === 'object' && Array.isArray(headerValue?.value)) {
    return headerValue.value.map((x) => String(x ?? '').trim()).filter(Boolean);
  }
  return String(headerValue).split(',').map((x) => x.trim()).filter(Boolean);
}

export function getCompanyRowTypesArray(rowData) {
  const raw = rowData?.types;
  if (Array.isArray(raw)) return raw.map((x) => String(x));
  if (typeof raw === 'string' && raw.trim() !== '') {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.map((x) => String(x));
    } catch (_) {
      /* ignore invalid JSON */
    }
  }
  return [];
}

export function getBusinessPartnerTypeSet(rowData) {
  const set = new Set(getCompanyRowTypesArray(rowData));
  const partyMode = String(rowData?.partner_status_by_type?.party_mode ?? '');
  if (partyMode === 'customer' || partyMode === 'client') set.add(partyMode);
  return set;
}

export function mapBusinessPartnerTypeToken(token, t) {
  if (token == null || token === '' || token === 'none') return '';
  const key = TYPE_I18N_KEYS[token];
  if (!key) return String(token);
  const tr = typeof t === 'function' ? t : (k) => k;
  const label = tr(key);
  return label == null || label === '' ? String(token) : String(label);
}

export function formatBusinessPartnerTypeText(rowData, t) {
  const labels = [];
  for (const token of getBusinessPartnerTypeSet(rowData)) {
    const label = mapBusinessPartnerTypeToken(token, t);
    if (label) labels.push(label);
  }
  return labels.length ? labels.join('/') : BUSINESS_PARTNER_TYPE_EMPTY_LABEL;
}

export function matchesBusinessPartnerTypeFilter(headerValue, rowData) {
  const selected = parseCompanyPartnerHeaderMulti(headerValue);
  if (selected.length === 0) return true;
  const rowTypes = getBusinessPartnerTypeSet(rowData);
  return selected.some((s) => rowTypes.has(String(s)));
}
